import script from "./DialogDrinkingWater.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogDrinkingWater.vue?vue&type=script&setup=true&lang=ts"

import "./DialogDrinkingWater.vue?vue&type=style&index=0&id=4c8a7a06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c8a7a06"]])

export default __exports__